export enum Type {
    BIRTH_RECORDS = "BIRTH_RECORDS",
    SOCIAL_SECURITY = "SOCIAL_SECURITY",
    GEORGIA_DFCS_BENEFITS = "GEORGIA_DFCS_BENEFITS",
    EMPLOYEE_PROFILE = "EMPLOYEE_PROFILE",
    GOAL_TRACKER = "GOAL_TRACKER",
    AMBASSADOR_PROGRAM = "AMBASSADOR_PROGRAM",
    PARTNER_PORTAL = "PARTNER_PORTAL",
    SITES = "SITES",
    CITIZENS = "CITIZENS",
    ANALYTICS = "ANALYTICS",
    TASKS = "TASKS",
    EQUIFAX_CHECKS = "EQUIFAX_CHECKS",
    NETWORK_PROCESSES_APPLICATIONS = "NETWORK_PROCESSES_APPLICATIONS",
    LIFT_2_0 = "LIFT_2_0",
    ONLINE_SOCIAL_SECURITY_APPLICATIONS = "ONLINE_SOCIAL_SECURITY_APPLICATIONS",
    HOUSING_READINESS = "HOUSING_READINESS",
    SHIPPING_LABEL_PRINTING = "SHIPPING_LABEL_PRINTING",
}

export enum Status {
    DISABLED = "DISABLED",
    ENABLED = "ENABLED",
    TEASED = "TEASED",
    HIDDEN = "HIDDEN"
}